import { render } from "./LitterInput.vue?vue&type=template&id=afb33c86&scoped=true"
import script from "./LitterInput.vue?vue&type=script&lang=js"
export * from "./LitterInput.vue?vue&type=script&lang=js"

import "./LitterInput.vue?vue&type=style&index=0&id=afb33c86&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb33c86"]])

export default __exports__